import Dexie from 'dexie';

// Remove all legacy versions, including same-account snapshots and principals.
export async function clearLocalData(): Promise<void> {
  await Dexie.delete('sad5-portal');
}
export async function bindLocalDataToPrincipal(): Promise<void> {
  await clearLocalData();
}
